<template>
  <v-container>
    <v-form ref="additional-shipping-lead-time-create-form">
      <v-row>
        <v-col class="mt-8" cols="6" offset="2">
          <v-alert v-if="validationErrorMessages && validationErrorMessages.length > 0" color="red lighten-2" dark>
            <ul v-for="validationErrorMessage in validationErrorMessages" v-bind:key="validationErrorMessage">
              <li>{{validationErrorMessage.message}}</li>
            </ul>
          </v-alert>
          <v-card class="mb-6">
            <base-card-title
                label="Create Additional Shipping Lead Time"
                icon="mdi-clock-plus"/>
            <v-row>
              <v-col cols="10" class="pb-0 pt-4 ml-6">
                <base-input-multi-select-with-freight-service
                    item-label="Freight services"
                    :freight-services="freightServices"
                    :grouped-freight-services="groupedFreightServices"
                    :selected-value="additionalShippingLeadTime.freightServiceIds"
                    :rules="[rules.selected]"
                    @change="additionalShippingLeadTime.freightServiceIds = arguments[0]"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="10" class="pb-0 pt-0 ml-6">
                <base-input-select-with-flag
                    item-label="Place of loading"
                    :items="placesOfLoading"
                    item-country="location.code"
                    item-text="description"
                    item-value="id"
                    :selected-value="additionalShippingLeadTime.placeOfLoadingId"
                    @change="additionalShippingLeadTime.placeOfLoadingId = arguments[0]"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="10" class="pb-0 pt-0 ml-6">
                <base-input-select-with-flag
                    item-label="Place of delivery"
                    :items="placesOfDelivery"
                    item-country="location.code"
                    item-text="description"
                    item-value="id"
                    :selected-value="additionalShippingLeadTime.placeOfDeliveryId"
                    @change="additionalShippingLeadTime.placeOfDeliveryId = arguments[0]"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="10" class="pb-0 pt-0 ml-6">
                <base-input-select-with-flag
                    item-label="Place of loading country"
                    :items="placeOfLoadingCountries"
                    item-country="code"
                    item-text="description"
                    item-value="id"
                    :selected-value="additionalShippingLeadTime.placeOfLoadingCountryId"
                    @change="additionalShippingLeadTime.placeOfLoadingCountryId = arguments[0]"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="10" class="pb-0 pt-0 ml-6">
                <base-input-select-with-flag
                    item-label="Place of delivery country"
                    :items="placeOfDeliveryCountries"
                    item-country="code"
                    item-text="description"
                    item-value="id"
                    :selected-value="additionalShippingLeadTime.placeOfDeliveryCountryId"
                    @change="additionalShippingLeadTime.placeOfDeliveryCountryId = arguments[0]"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="10" class="pb-0 pt-0 ml-6">
                <base-input-number-field
                    item-label="Additional lead time (days)"
                    :rules="[rules.minDays, rules.maxDays]"
                    :value="additionalShippingLeadTime.additionalLeadTimeInDays"
                    @blur="additionalShippingLeadTime.additionalLeadTimeInDays = arguments[0]"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="10" class="pb-0 pt-0 ml-6">
                <base-input-select-date-picker
                    item-label="Valid from"
                    :selected-value="additionalShippingLeadTime.validFrom"
                    :rules="[rules.required]"
                    @change="additionalShippingLeadTime.validFrom = arguments[0]"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="10" class="pb-0 pt-0 ml-6">
                <base-input-select-date-picker
                    item-label="Valid to"
                    :selected-value="additionalShippingLeadTime.validTo"
                    :rules="[rules.fromDateIsBeforeToDate]"
                    @change="additionalShippingLeadTime.validTo = arguments[0]"/>
              </v-col>
            </v-row>
          </v-card>
          <base-input-primary-button
              label="save"
              icon="mdi-arrow-right-bold-circle"
              @click="save"/>

          <base-input-secondary-button
              label="cancel"
              icon="mdi-cancel"
              @click="cancel"/>
        </v-col>
      </v-row>
    </v-form>
    <base-dialog-send
        label="Additional shipping lead time has been saved successfully!"
        @create="createNew"
        @search="search"
        :show-copy="false"
        :send-dialog="sendDialog"/>
  </v-container>
</template>

<script>
import axios from 'axios'
import BaseDialogSend from '@/base/dialog/BaseDialogSend'
import { validateDate } from '@/validation/customvalidation'
import BaseInputSecondaryButton from '@/base/input/BaseInputSecondaryButton'
import BaseInputPrimaryButton from '@/base/input/BaseInputPrimaryButton'
import BaseInputSelectWithFlag from '@/base/input/BaseInputSelectWithFlag'
import BaseCardTitle from '@/base/card/BaseCardTitle'
import BaseInputNumberField from '@/base/input/BaseInputNumberField'
import BaseInputSelectDatePicker from '@/base/input/BaseInputSelectDatePicker'
import BaseInputMultiSelectWithFreightService from '@/base/input/BaseInputMultiSelectWithFreightService'
import { mapGetters } from 'vuex'

export default {
  name: 'CreateAdditionalShippingLeadTime',
  components: { BaseInputMultiSelectWithFreightService, BaseInputSelectDatePicker, BaseInputNumberField, BaseCardTitle, BaseInputSelectWithFlag, BaseInputPrimaryButton, BaseInputSecondaryButton, BaseDialogSend },
  data () {
    return {
      sendDialog: false,
      validationErrorMessages: [],
      additionalShippingLeadTime: {
        placeOfLoadingId: '',
        placeOfDeliveryId: '',
        placeOfLoadingCountryId: '',
        placeOfDeliveryCountryId: '',
        freightServiceIds: [],
        additionalLeadTimeInDays: '',
        validFrom: '',
        validTo: ''
      },
      rules: {
        required: value => !!value || 'Required.',
        selected: value => value.length > 0 || 'Select one of the item.',
        fromDateIsBeforeToDate: value => validateDate(this.additionalShippingLeadTime.validFrom, value) || 'Valid to date cannot be before valid from date.',
        minDays: value => (value > 0) || 'Required a value between 1 and 100.',
        maxDays: value => (value <= 100) || 'Required a value between 1 and 100.'
      }
    }
  },
  computed: {
    ...mapGetters([
      'freightServices',
      'groupedFreightServices',
      'placesOfLoading',
      'placesOfDelivery',
      'placeOfLoadingCountries',
      'placeOfDeliveryCountries',
      'additionalShippingLeadTimeSearchCriteria',
      'getUserRoles'
    ])
  },
  async mounted () {
    await axios.all([
      this.$store.dispatch('getAllFreightServices'),
      this.$store.dispatch('getAllGroupedFreightServices'),
      this.$store.dispatch('getAllPlacesOfLoading'),
      this.$store.dispatch('getAllPlacesOfDelivery'),
      this.$store.dispatch('getPlaceOfLoadingCountries'),
      this.$store.dispatch('getPlaceOfDeliveryCountries')
    ]).then(() => { this.isLoaded = true })
  },
  methods: {
    validate () {
      return this.$refs['additional-shipping-lead-time-create-form'].validate()
    },
    save () {
      if (this.validate()) {
        axios.post('/api/touchpoint/additional-shipping-lead-time', this.additionalShippingLeadTime)
          .then((response) => {
            if (response.data.status === 'SUCCESS') {
              this.sendDialog = true
            } else {
              this.validationErrorMessages = response.data.errorMessageList
              window.scrollTo(0, 0)
            }
          })
          .catch(e => console.log(e))
      } else {
        window.scrollTo(0, 0)
      }
    },
    cancel () {
      this.$router.push({ name: 'SearchAdditionalShippingLeadTime' })
    },
    createNew () {
      this.sendDialog = false
      this.additionalShippingLeadTime = {
        placeOfLoadingId: '',
        placeOfDeliveryId: '',
        placeOfLoadingCountryId: '',
        placeOfDeliveryCountryId: '',
        freightServiceIds: [],
        additionalLeadTimeInDays: '',
        validFrom: '',
        validTo: ''
      }
      this.$refs['additional-shipping-lead-time-create-form'].reset()
    },
    search () {
      this.$router.push({ name: 'SearchAdditionalShippingLeadTime' })
    }
  }
}
</script>

<style scoped>
</style>
